import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import { Box } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import { red } from "@mui/material/colors";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
const imageMimeType = /image\/(png|jpg|jpeg)/i;

function Addann() {
  const [file, setFile] = useState(null);
  const [fileDataURL, setFileDataURL] = useState(null);

  const changeHandler = (e) => {
   
    const file = e.target.files[0];
   
    if (!file.type.match(imageMimeType)) {
      alert("Image mime type is not valid");
      return;
    }
    setFile(file);
  };

  useEffect(() => {
    
    let fileReader,
      isCancel = false;
    if (file) {
      
      fileReader = new FileReader();
      fileReader.onload = (e) => {
        const { result } = e.target;
        if (result && !isCancel) {
          setFileDataURL(result);
        }
      };
      fileReader.readAsDataURL(file);
    }
    return () => {
      isCancel = true;
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort();
      }
    };
  }, [file]);

  const navigate = useNavigate();
  const [loginInput, setLogin] = useState({
    text: "",
    date: "",
    image: "",
    error_list: [],
  });
  const handeleInput = (e) => {
    e.persist();
    setLogin({ ...loginInput, [e.target.name]: e.target.value });
  };

  const loginSubmit = (e) => {
    const data = {
      text: loginInput.text,
      date: loginInput.date,
      image: fileDataURL,
    };

    axios.post(`${BaseUrl}/api/announcements`, data).then((res) => {
      if (res.data.code === 200) {
        navigate("/announcements");
       
      } else {
        setLogin({ ...loginInput, error_list: res.data.error });
      }
    });
 
  };

  return (
    <React.Fragment>
      <Box class="addusers">
        <Card
          sx={{ maxWidth: 1000 }}
          style={{
            position: "relative",
            top: "50%",
            left: "20%",
          }}
        >
          <CardHeader
            avatar={
              <Avatar
                sx={{ bgcolor: red[500] }}
                aria-label="recipe"
                style={{
                  width: "100px",
                  height: "100px",
                }}
              ></Avatar>
            }
          />

          <Box m="20px">
            <Formik
              initialValues={{
                text: "",
                datte: "",
              }}
              onSubmit={loginSubmit}
            >
              {({ errors, touched, setFieldValue, values }) => (
                <Form>
                  <Box
                    display="grid"
                    gap="30px"
                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  ></Box>
                  <Field
                    fullWidth
                    variant="filled"
                    value={loginInput.text}
                    placeholder="Announcement Title"
                    onChange={handeleInput}
                    sx={{ gridColumn: "span 2" }}
                    name="text"
                  />
                  {errors.text && touched.text ? (
                    <div>{errors.text}</div>
                  ) : null}
                  <Field
                    name="date"
                    fullWidth
                    variant="filled"
                    value={loginInput.date}
                    placeholder="yyyy-mm-dd"
                    type="date"
                    onChange={handeleInput}
                    sx={{ gridColumn: "span 2" }}
                  />
                  {errors.date && touched.date ? (
                    <div>{errors.date}</div>
                  ) : null}

                  <label for="file">File upload</label>
                  <input
                    id="file"
                    name="image"
                    type="file"
                    onChange={changeHandler}
                    accept=".png, .jpg, .jpeg"
                    className="form-control"
                  />

                  <Box display="flex" justifyContent="end" mt="20px">
                    <button
                      type="submit"
                      color="secondary"
                      variant="contained"
                      style={{
                        background: "#d84444",
                      }}
                    >
                      Submit{" "}
                    </button>
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
        </Card>
      </Box>
    </React.Fragment>
  );
}
export default Addann;
